import { useMutation } from '@tanstack/react-query'
import type { MemberImportRowInput } from '@riverpark/types'
import { confirmMemberImport, notifyImportedMembers, previewMemberImport } from '@/lib/members'

export function useMemberImportPreview() {
  return useMutation({
    mutationFn: (rows: MemberImportRowInput[]) => previewMemberImport(rows),
  })
}

export function useMemberImportConfirm() {
  return useMutation({
    mutationFn: ({ rows, notify }: { rows: MemberImportRowInput[]; notify: boolean }) =>
      confirmMemberImport(rows, notify),
  })
}

export function useMemberImportNotify() {
  return useMutation({
    mutationFn: (memberIds: string[]) => notifyImportedMembers(memberIds),
  })
}
